import { ICON_ONLY_ATTRIBUTE } from "ui/tabs/tabs.constants";
import { isIconOnlyTab } from "ui/tabs/tabs.helpers";
import { type TabProps } from "ui/tabs/tabs.types";

type UseTabProps = Pick<TabProps, "label" | "startIcon">;

export const useTab = ({ label, startIcon }: UseTabProps) => ({
  iconOnlyProps: isIconOnlyTab(label, startIcon) ? { [ICON_ONLY_ATTRIBUTE]: true } : {},
});
